import React from "react";
import { Check } from "lucide-react";
import { ICONS } from "../../utils/icons";
import { getDepartmentClassLabel } from "../../utils/studentDisplay";
import {
  ATTENDANCE_VIEW_DAILY_LIST_CONTAINER_CLASS,
  ATTENDANCE_VIEW_DAILY_LIST_GRID_CLASS,
  getAttendanceViewDailyListCheckboxClass,
  getAttendanceViewDailyListRowClass,
  getAttendanceViewDailyListStatusButtonClass,
  getAttendanceViewDailyListStatusDotClass,
} from "./attendanceViewStyles";

export default function AttendanceDailyListRows({
  brand,
  dailyAttendance,
  filteredStudents,
  handleSelectRow,
  handleStatusChange,
  isMobile,
  selectedDepartment,
  selectedIds,
  targetGroup,
  handleMarkDragStart,
  handleSelectDragStart,
  handleDragOver,
  isDragging,
  dragStatus,
}) {
  return (
    <div className={ATTENDANCE_VIEW_DAILY_LIST_CONTAINER_CLASS}>
      <div className={`${ATTENDANCE_VIEW_DAILY_LIST_GRID_CLASS} ${isMobile ? "px-3 pt-2" : ""}`}>
        {filteredStudents.map((student) => {
          const status = dailyAttendance[student.id];
          const isSelected = selectedIds.includes(student.id);
          const showDepartment = targetGroup !== "students" || selectedDepartment === "All";
          const affiliationLabel = getDepartmentClassLabel(student, { showDepartment });

          return (
            <div
              key={student.id}
              data-id={student.id}
              onMouseDown={(e) => {
                // Only start selection drag if clicking the row background, not the status buttons
                if (e.target.closest('button')) return;
                e.stopPropagation();
                handleSelectDragStart?.(student.id, e);
              }}
              onMouseEnter={() => handleDragOver?.(student.id)}
              className={`${getAttendanceViewDailyListRowClass(isSelected, brand)} selection-item ${student.faithState === "장기결석" && !isSelected ? "opacity-50 grayscale-[0.5]" : ""}`}
            >
              <div className={`${getAttendanceViewDailyListCheckboxClass(isSelected, brand)} pointer-events-none`}>
                {isSelected && <Check size={12} className="text-white" />}
              </div>

              <div className="flex items-center gap-3 flex-1 min-w-0 pointer-events-none">
                <div className="relative flex-shrink-0">
                  {student.photoUrl ? (
                    <img src={student.photoUrl} alt="" className="w-10 h-10 rounded-[14px] object-cover border border-white shadow-sm" />
                  ) : (
                    <div className="w-10 h-10 rounded-[14px] bg-white flex items-center justify-center border border-white shadow-sm overflow-hidden">
                      <img src={targetGroup === "teachers" ? (student.gender === "여" ? ICONS.teacher_female : ICONS.teacher_male) : (student.gender === "남" ? "/images/boy_3d_light.png" : (student.gender === "여" ? "/images/girl_3d_light.png" : "/images/boy_3d_light.png"))} alt="avatar" className="w-full h-full object-cover transform scale-110" />
                    </div>
                  )}
                  {student.faithState === "초신자" && (
                    <div className="absolute -bottom-1 -right-1 bg-yellow-400 text-white text-[7px] font-black px-1 py-0.5 rounded-full shadow-sm border border-white z-10">N</div>
                  )}
                  {student.faithState === "장기결석" && (
                    <div className="absolute -bottom-1 -right-1 bg-gray-500 text-white text-[6px] font-black px-1 py-0.5 rounded-full shadow-sm border border-white z-10">L</div>
                  )}
                </div>

                <div className="min-w-0">
                  <div className="font-black text-gray-800 text-sm truncate">{student.name}</div>
                  {affiliationLabel && (
                    <div className="text-[11px] text-gray-400 font-bold truncate">{affiliationLabel}</div>
                  )}
                </div>
              </div>

              <div className="flex gap-1" onMouseEnter={(e) => e.stopPropagation()}>
                <button
                  onMouseDown={(e) => { e.preventDefault(); e.stopPropagation(); handleMarkDragStart?.("present", student.id, e); }}
                  onClick={(e) => { e.stopPropagation(); handleStatusChange(student.id, "present"); }}
                  className={getAttendanceViewDailyListStatusButtonClass(status, "present")}
                >
                  <div className={getAttendanceViewDailyListStatusDotClass(status, "present")}></div>
                </button>
                <button
                  onMouseDown={(e) => { e.preventDefault(); e.stopPropagation(); handleMarkDragStart?.("late", student.id, e); }}
                  onClick={(e) => { e.stopPropagation(); handleStatusChange(student.id, "late"); }}
                  className={getAttendanceViewDailyListStatusButtonClass(status, "late")}
                >
                  <div className={getAttendanceViewDailyListStatusDotClass(status, "late")}></div>
                </button>
                <button
                  onMouseDown={(e) => { e.preventDefault(); e.stopPropagation(); handleMarkDragStart?.("absent", student.id, e); }}
                  onClick={(e) => { e.stopPropagation(); handleStatusChange(student.id, "absent"); }}
                  className={getAttendanceViewDailyListStatusButtonClass(status, "absent")}
                >
                  <div className={getAttendanceViewDailyListStatusDotClass(status, "absent")}></div>
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
